import { render } from "./AeracaoAcoes.vue?vue&type=template&id=fe4ad548"
import script from "./AeracaoAcoes.vue?vue&type=script&lang=js"
export * from "./AeracaoAcoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__